import { makeStyles } from "@fluentui/react-components";
import { projectIqTokens } from "apps/project-iq/theme/projectIqTokens";

export const useWorkspaceCardStyles = makeStyles({
  card: {
    position: "relative",
    display: "flex",
    flexDirection: "column",
    gap: "10px",
    backgroundColor: projectIqTokens.card,
    borderRadius: "16px",
    border: `1px solid ${projectIqTokens.line}`,
    padding: "18px",
    cursor: "pointer",
    transition: "box-shadow 0.18s, transform 0.18s, border-color 0.18s",
    boxShadow: projectIqTokens.shadowSm,
    userSelect: "none",
    ":hover": {
      boxShadow: projectIqTokens.shadow,
      transform: "translateY(-2px)",
    },
    ":focus-visible": {
      outline: `2px solid ${projectIqTokens.teal}`,
      outlineOffset: "2px",
    },
  },
  pinBtn: {
    width: "30px",
    height: "30px",
    minWidth: "30px",
    borderRadius: "8px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    border: "none",
    background: "transparent",
    cursor: "pointer",
    padding: 0,
    flexShrink: 0,
    visibility: "hidden",
    opacity: 0,
    transition:
      "background 0.12s, border-color 0.12s, opacity 0.12s, visibility 0.12s",
  },
  pinBtnVisible: {
    visibility: "visible",
    opacity: 1,
  },
  cardTop: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "8px",
  },
  clientRow: {
    display: "flex",
    alignItems: "center",
    gap: "6px",
    overflow: "hidden",
    flex: 1,
  },
  clientDot: {
    width: "7px",
    height: "7px",
    minWidth: "7px",
    borderRadius: "999px",
    flexShrink: 0,
  },
  clientName: {
    fontSize: "13px",
    fontWeight: "600",
    color: projectIqTokens.muted,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
  statusBadge: {
    fontSize: "12px",
    fontWeight: "700",
    padding: "3px 9px",
    borderRadius: "999px",
    flexShrink: 0,
    whiteSpace: "nowrap",
  },
  nameBlock: {
    display: "flex",
    flexDirection: "column",
    flex: 1,
  },
  workspaceName: {
    fontSize: "18px",
    fontWeight: "700",
    color: projectIqTokens.ink,
    lineHeight: "1.25",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
  codeLine: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    fontSize: "12.5px",
    color: projectIqTokens.faint,
  },
  cardFooter: {
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
    marginTop: "2px",
    gap: "8px",
  },
  avatarRow: {
    display: "flex",
    alignItems: "center",
    flexShrink: 0,
  },
  avatar: {
    width: "26px",
    height: "26px",
    minWidth: "26px",
    borderRadius: "999px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "10px",
    fontWeight: "700",
    color: projectIqTokens.card,
    flexShrink: 0,
  },
  overflowAvatar: {
    width: "26px",
    height: "26px",
    minWidth: "26px",
    borderRadius: "999px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "9px",
    fontWeight: "700",
    color: projectIqTokens.muted,
    backgroundColor: projectIqTokens.line2,
    flexShrink: 0,
  },
});
